import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';

/** Top-end action button surface: 48×48, 12px radius, gray-800. */
export const HEADER_BUTTON_CLASS =
    'flex size-12 items-center justify-center rounded-xl bg-gray-800 p-px';

interface MeetingHeaderButtonProps {
    iconKey: IconKey;
    onClick: () => void;
    ariaLabel?: string;
    dataTestId?: string;
}

/** A single icon button in the meeting header's top-end action row. */
const MeetingHeaderButton: React.FC<MeetingHeaderButtonProps> = ({
    iconKey,
    onClick,
    ariaLabel,
    dataTestId,
}) => (
    <IconButton
        className={HEADER_BUTTON_CLASS}
        onClick={onClick}
        aria-label={ariaLabel}
        dataTestId={dataTestId}
    >
        <Icon iconKey={iconKey} />
    </IconButton>
);

export default MeetingHeaderButton;
